import { Image, Text, View } from '@react-pdf/renderer';

import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import ei6 from '@assets/images/ei-6.jpg';
import { multiTouchPointItems } from '@utils/constants';
import { styles } from '../../styles';
import { useTranslation } from 'react-i18next';

interface KeyTopicsProps {
  event: PublicEventDetailsResponse;
}

const WhoWhy = ({ event }: KeyTopicsProps) => {
  const { t } = useTranslation();

  return (
    <View style={styles.whoWhyPageWrapper}>
      <View style={styles.whoWhyTitleWrapper}>
        <Text style={styles.whoWhyTitle}> {t('who-&-why-.')}</Text>
      </View>
      <View style={styles.multiTouchPointsWrapper}>
        {multiTouchPointItems?.slice(0, 9)?.map(item => (
          <View
            style={styles.multiTouchPointsItem}
            wrap={false}
            key={item.title}
          >
            <Text style={styles.multiTouchPointItemTitle}>{t(item.title)}</Text>
            <View style={styles.multiTouchPointBodyWrapper}>
              <View style={styles.multiTouchTextWrapper}>
                <Text style={styles.whiteSubtitle}>{t(item.subtitle)}</Text>
              </View>
              <View style={styles.multiTouchImageWrapper}>
                <Image style={styles.image} src={ei6} />
              </View>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

export default WhoWhy;
